import angular from 'angular';
import books from '../../books';
import { BankAccountSetupDialogService } from './BankAccountSetupDialog';
import { HelpDialogService } from './HelpDialog';
import { importDialogDirective } from './importDialog';
import { PendingItemDialogService } from './PendingItemDialog';

export default angular
  .module('csm.books.InitialSetup.dialogs', [
    'ui.grid',
    'ui.grid.edit',
    'ui.grid.selection',
    'ui.grid.cellNav',
    'ui.grid.emptyBaseLayer',
    'ui.grid.resizeColumns',
    books
  ])
  .service('BankAccountSetupDialog', BankAccountSetupDialogService)
  .service('HelpDialog', HelpDialogService)
  .directive('importDialog', importDialogDirective)
  .service('PendingItemDialog', PendingItemDialogService).name;
